import { Doc } from '@dadohr/shared/domainTypes/document';
import { IExperienceDenormalized } from '@dadohr/shared/domainTypes/experience';
// import ENV from '../../../../../env.json';
import { usePromise } from '../../../../../hooks/usePromise';

export const SsoTestPage = ({ accessToken }: { accessToken: string }) => {
  const [doc, loading, error] = usePromise(() => {
    const url = new URL(window.location.origin);
    url.pathname = '/api/getExperienceProtected';
    url.searchParams.set('accessToken', accessToken);
    url.searchParams.set('currentUrl', window.location.href);
    return fetch(url.toString(), {
      redirect: 'follow',
      headers: {
        Accept: 'application/json'
        // Authorization: authToken ? `Bearer ${authToken}` : ''
      }
    }).then(async (r) => {
      console.log('response', r);
      const d:
        | {
            status: 'SSO_REDIRECT';
            location: string;
          }
        | {
            status: 'OK';
            experience: Doc<IExperienceDenormalized>;
          } = await r.json();
      if (d.status === 'SSO_REDIRECT') {
        window.location.href = d.location;
      }

      return d;
    });
  }, [accessToken]);
  if (loading || doc?.status === 'SSO_REDIRECT') {
    return <div>Loading...</div>;
  }

  if (doc) {
    return <div>{JSON.stringify(doc, null, 2)}</div>;
  }
  return <div>{error?.message || 'ERROR'}</div>;
};
